import { render, staticRenderFns } from "./BesarPenyakitKunjunganRajal.vue?vue&type=template&id=27d3c048"
import script from "./BesarPenyakitKunjunganRajal.vue?vue&type=script&lang=js"
export * from "./BesarPenyakitKunjunganRajal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d3c048')) {
      api.createRecord('27d3c048', component.options)
    } else {
      api.reload('27d3c048', component.options)
    }
    module.hot.accept("./BesarPenyakitKunjunganRajal.vue?vue&type=template&id=27d3c048", function () {
      api.rerender('27d3c048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/morbiditas-rajal/BesarPenyakitKunjunganRajal.vue"
export default component.exports